import React, { useState, useEffect } from "react";
import Image from "next/image";
import { ReviewStar as Icon_ReviewStar } from "@/components/customer/icons/ReviewStar";
const SvgIcons = { ReviewStar: Icon_ReviewStar };


import vLogo from "../components/images/vilva-new-logo-white.webp";


import Link from "next/link";
import { getImageUrl } from "@/lib/imageUrl";
import GlobalPartnersCount from "@/components/GlobalPartnersCount";

interface Testimonial {
  id: number;
  front: {
    text: string;
    store: string;
    title: string;
    avatar: any; // Use `any` for Next.js Image source; replace with proper type if known
  };
  back: string;
}

export const SigninRightSec = () => {
const testimonials: Testimonial[] = [
  {
    id: 1,
    front: {
      text: "Our business website went from outdated to cutting-edge in no time. The team understood our vision and delivered a seamless, fast, and beautifully designed site. Highly recommended!",
      store: "Magizh Handicrafts",
      title: "Ganapathi (CEO & Founder)",
      avatar: getImageUrl("/vilvabusiness/website/common/testimonials/magizh.webp"),
    },
    back: "Back 1",
  },
  {
    id: 2,
    front: {
      text: "I recently got my website developed by Vilva Business, and I must say, their service was outstanding! From the initial consultation to the final launch, the team was highly professional, responsive, and creative.",
      store: "Zemdrop",
      title: "Yuvraj (CEO & Founder)",
      avatar: getImageUrl("/vilvabusiness/website/common/testimonials/zemdrop.webp"),
    },
    back: "Back 2",
  },
  {
    id: 3,
    front: {
      text: "A game-changer for our online presence. The design is sleek, and the functionality is top-notch! The support team was responsive, and the project was delivered on time with great attention to detail.",
      store: "Ayyawins",
      title: "Ram Dhanapal (CEO & Founder)",
      avatar: getImageUrl("/vilvabusiness/website/common/testimonials/ram.webp"),
    },
    back: "Back 3",
  },
  {
    id: 4,
    front: {
      text: "I give Vilva D2C a 5/5 rating and have already recommended them to family and friends. I will continue to recommend them to everyone. Technical team is very supportive and fulfill our requirements.",
      store: "Adyarhandicrafts",
      title: "Manikandan (CEO & Founder)",
      avatar: getImageUrl("/vilvabusiness/website/common/testimonials/adyar.webp"),
    },
    back: "Back 4",
  },
  {
    id: 5,
    front: {
      text: "Vilva Team is building my E-Commerce website and getting great support, understanding my requirements. I see good progress with timely updates. Satisfied with their amazing service.",
      store: "A & G",
      title: "Ananda (CEO & Founder)",
      avatar: getImageUrl("/vilvabusiness/website/common/testimonials/ag.webp"),
    },
    back: "Back 5",
  },
  {
    id: 6,
    front: {
      text: "Vilva Networks offers 24/7 support with accountability, monitoring, and prompt technical assistance. Their proactive approach and attention to detail make them a reliable tech partner.",
      store: "Nalsshoppy",
      title: "Sivasamy (CEO & Founder)",
      avatar: getImageUrl("/vilvabusiness/website/common/testimonials/siva.webp"),
    },
    back: "Back 6",
  },
  {
    id: 7,
    front: {
      text: "The development of the Thaithingal website has experienced significant growth over the last decade, thanks to Vilva Networks. Their expertise and ongoing support were key to our success.",
      store: "Thaithingal",
      title: "Manikandan (CEO & Founder)",
      avatar: getImageUrl("/vilvabusiness/website/common/testimonials/thaithingal.webp"),
    },
    back: "Back 7",
  },
  {
    id: 8,
    front: {
      text: "Vilva Network is building my e commerce website ad getting a great support to understand my exact requirements. They are providing me with regular update in timely manner. Wishing you to continue provide the excellent support with same team spirit.",
      store: "Jonas International",
      title: "Oliver Fernandes (CEO & Founder)",
      avatar: getImageUrl("/vilvabusiness/website/common/testimonials/jonsInternatinal.webp"),
    },
    back: "Back 8",
  },
];


  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    // prefers-reduced-motion: swap testimonials instantly, never fade.
    const reduce = typeof window !== 'undefined'
      && window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;

    const interval = setInterval(() => {
      if (reduce) {
        setCurrentTestimonialIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
        return;
      }
      setFade(false); // Start fade-out
      setTimeout(() => {
        setCurrentTestimonialIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
        setFade(true); // Start fade-in
      }, 220); // Matches the 200ms fade-out below, plus a frame.
      // Was 600ms against a 500ms fade, so the card sat visibly blank for ~0.4s out of every
      // 8s. Landing in that window is what made the trust panel look like an empty placeholder
      // box — measured at 428ms / 366ms / 364ms per cycle before this change.
    }, 8000); // Change every 8 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [testimonials.length]);

  const currentTestimonial = testimonials[currentTestimonialIndex];

  return (
    <div>
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @keyframes fadeOut {
          from {
            opacity: 1;
          }
          to {
            opacity: 0;
          }
        }
        .fade-in {
          animation: fadeIn 0.2s ease-in;
        }
        /* forwards holds the card at 0 until the swap lands. Without it the animation snapped
           back to opacity 1 with the OLD text still in place, flashing the previous
           testimonial for a frame before the new one faded in. */
        .fade-out {
          animation: fadeOut 0.2s ease-out forwards;
        }
        @media (prefers-reduced-motion: reduce) {
          .fade-in,
          .fade-out {
            animation: none;
            opacity: 1;
          }
        }
      `}</style>
      <div className="h-full flex flex-col gap-16 w-full justify-between">
        <div className="h-full">
         <Link href={'/'}> <Image src={vLogo} alt="Vilva Business Logo" className="w-[130px] mx-auto mb-8" width={130} height={40} /></Link>
          <div
            className={`flex  w-full h-full p-[24px] flex-col schibsted-grotesk justify-start items-start gap-[20px] rounded-[8px] border-white/30 border-[0.6px] bg-white/10 backdrop-blur-[10px] `}
          >
            <p className={`text-white text-[18px] font-normal leading-[150%] schibsted-grotesk ${
              fade ? "fade-in schibsted-grotesk" : "fade-out schibsted-grotesk"
            }`}>
              “{currentTestimonial.front.text}
            </p>
            <div className="flex items-center">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center mr-3 overflow-hidden ${
              fade ? "fade-in" : "fade-out"
            }`}>
                <Image
                  src={currentTestimonial.front.avatar}
                  alt={`${currentTestimonial.front.title} avatar`}
                  className="w-[32px] h-[32px] rounded-full object-cover"
                  width={300} height={300}
                />
              </div>
              <div className="space-y-[4px]">
                <p className={`text-white text-[14px]  font-normal leading-[100%] schibsted-grotesk ${
                    fade ? "fade-in" : "fade-out"}`}  style={{ fontFamily: "Schibsted Grotesk, sans-serif" }}>
                  {currentTestimonial.front.title}
                </p>
                <p className={`text-[#CBDDFF] m-0 p-0 text-[12px] tracking-wide font-normal leading-[100%] schibsted-grotesk ${
                    fade ? "fade-in" : "fade-out"}`}  style={{ fontFamily: "Schibsted Grotesk, sans-serif" }}>
                  {currentTestimonial.front.store}
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center mt-[24px]">
            <a href="https://maps.app.goo.gl/wxZr7ckDhrWnVbx27" aria-label="Review" className="text-[#090D28]" target="_blank" rel="noopener noreferrer">
              <p className="m-0 flex items-center gap-1 p-0 pb-[6px] text-center schibsted-grotesk text-sm font-normal leading-[120%] text-[#fff]">
                <Image className="w-6" src={getImageUrl("/vilvabusiness/website/common/homepage/google-img.webp")} alt="Google Reviews" width={50} height={50} /> Google Reviews
              </p>
            </a>
            <div className="flex items-center gap-2 font-LatinkaBold">
              4.7
              <div className="flex items-center gap-[2px]">
                <SvgIcons.ReviewStar />
                <SvgIcons.ReviewStar />
                <SvgIcons.ReviewStar />
                <SvgIcons.ReviewStar />
                <SvgIcons.ReviewStar />
              </div>
            </div>
          </div>
        </div>
        <div className="flex h-full mt-auto items-end ">
          <div>
          <p className="text-[#6E99E0] text-center text-[14px] font-normal leading-[100%] schibsted-grotesk mb-6">
            Join over <GlobalPartnersCount />+ Global Partners
          </p>
          <div className="grid grid-cols-3 gap-4 px-4">
            <div>
              <Image src={getImageUrl("/vilvabusiness/website/common/auth_img/Logo.webp")} className="h-[23px] object-contain" alt="Partner Logo 1" width={150} height={150}/>
            </div>
            <div>
              <Image src={getImageUrl("/vilvabusiness/website/common/auth_img/digitalocean-logo-vector%20(1).webp")} className="h-[23px] object-contain" alt="Partner Logo 2"  width={170} height={170} />
            </div>
            <div>
              <Image src={getImageUrl("/vilvabusiness/website/common/auth_img/Amazon_Web_Services-Logo.wine%202.webp")} className="h-[23px] object-contain" alt="Partner Logo 3"  width={170} height={170} />
            </div>
            <div>
              <Image src={getImageUrl("/vilvabusiness/website/common/auth_img/Cloudflare-Logo.wine%202.webp")} className="h-[23px] object-contain" alt="Partner Logo 4"  width={170} height={170} />
            </div>
            <div>
              <Image src={getImageUrl("/vilvabusiness/website/common/auth_img/white.webp")} className="h-[23px] object-contain" alt="Partner Logo 5"  width={170} height={170} />
            </div>
            <div>
              <Image src={getImageUrl("/vilvabusiness/website/common/auth_img/PhonePe-Logo.wine%20(2).webp")} className="h-[23px] object-contain" alt="Partner Logo 6"  width={170} height={170} />
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};
